/**
 * Created by Vladislav on 04.09.2024.
 */

Reward.register("stickers", {
    countable: true,
    flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,

    getIcon: function () {
        return bundles.reward_icons.frames.stickers_png;
    },

    getPrice: function (value) {
        const pack = VirtualProducts.stickers2;
        return pack.price / pack.reward.stickers * value;
    },

    parse: function (value, options) {
        if (cleverapps.stickersBook.isAvailable() && cleverapps.stickersBook.getAvailableCollections().length) {
            return new Reward("stickers", value, options);
        }
        return [];
    },

    receive: function (value, options) {
        options = options || {};
        let source;

        if (options.event !== undefined) {
            if (options.event === cleverapps.EVENTS.EARN.LEVEL_COMPLETE || options.event === cleverapps.EVENTS.EARN.BONUS_LEVEL_REWARD) {
                source = Sticker.SOURCES.level;
            } else if (options.event.indexOf("stickerspack") !== -1) {
                source = Sticker.SOURCES.buy;
            } else if (options.event === cleverapps.EVENTS.EARN.DAILY_TASKS) {
                source = Sticker.SOURCES.dailyTasks;
            } else if (options.event === cleverapps.EVENTS.EARN.CHAT_PRESENT) {
                source = Sticker.SOURCES.support;
            } else if (options.event === cleverapps.EVENTS.EARN.WEEKLY_GOALS) {
                source = Sticker.SOURCES.weeklyGoals;
            } else {
                source = options.event;
            }
        }

        cleverapps.stickersBook.givePrize(value, source);

        return function () {};
    }
});

Reward.register("joker", {
    countable: true,
    getIcon: function () {
        return bundles.reward_icons.frames.stickers_joker_png;
    },

    parse: function (value, options) {
        if (cleverapps.stickersBook.isAvailable() && cleverapps.stickersBook.getAvailableCollections().length) {
            return new Reward("joker", value, options);
        }
        return [];
    },

    receive: function (value) {
        cleverapps.stickersBook.addJokers(value);

        return function () {};
    }
});